import React from 'react';
import ClimateMap from './ClimateMap';

function App() {
  return <ClimateMap />;
}

export default App;
